module.exports = __webpack_public_path__ + "img/haibao1@2x_new.3c13b93f.png";